import { UserIconFilled } from '@/components/icons'
import { useAppSelector } from '@/hooks/useRedux'
import { userSelector } from '@/pages/user/selectors'
import { Button } from '../button'

type Props = {
  buttonClass?: string
  imgClass?: string
  toggleShowProfileMenu?: () => void
  toggleShowDropdown?: () => void
}

export const ProfileMenu = ({ buttonClass, imgClass, toggleShowProfileMenu, toggleShowDropdown }: Props) => {
  const { user } = useAppSelector(userSelector)

  return (
    <>
      <Button className={`md:flex hidden ${buttonClass}`} onClick={toggleShowDropdown}>
        {user?.imageUrl ? (
          <img src={user?.imageUrl} alt={user.fullName} className={`rounded-full ${imgClass}`} />
        ) : (
          <UserIconFilled className="w-10 h-10 text-primary" />
        )}
      </Button>
      <Button className="flex md:hidden" onClick={toggleShowProfileMenu}>
        {user?.imageUrl ? (
          <img src={user?.imageUrl} alt={user.fullName} className={`rounded-full ${imgClass}`} />
        ) : (
          <UserIconFilled className="w-10 h-10 text-primary" />
        )}
      </Button>
    </>
  )
}
